import { api } from "../../shared/hooks/api";

const ACTIVE_MATERIALS_URL = `/materials?option=outsource_materials&is_active=true&page_size=${Number.MAX_SAFE_INTEGER}`;

export const useActiveMaterialsCatalog = (skip = false, providerId?: string) => {
    const url = ACTIVE_MATERIALS_URL + (providerId !== undefined ? `&outsource_provider_id=${providerId}` : "");
    const [{ data, isLoading, error }, fetchMaterials] = api.get(
        url,
        undefined,
        skip || providerId === "",
    );

    return {
        materials: providerId === "" ? [] : data?.results || [],
        isLoading,
        error,
        fetchMaterials: (...args: any[]) => providerId === "" ? undefined : fetchMaterials(...args),
    };
};
